import { Link } from "react-router-dom";
import { Plus, MailOpen, Inbox } from "lucide-react";

import { groupContext, groupName, groupHref } from "@/lib/v3Groups";
import { ConnectionError } from "../components/ConnectionError";
import { Loading } from "../components/kit";
import { V3Title, V3Actions, V3_PRIMARY } from "../components/v3";
import { ResultTable, ResultRow, V3_GHOST } from "../components/v3app";
import { useGroups } from "../components/v3groups";

const initial = (g) => Array.from(groupName(g))[0]?.toLocaleUpperCase("de") || "K";

// M14: circles from GET /member/groups; the context shows the join rule and own membership as the Core reports them.
export default function Groups() {
  const res = useGroups();
  const list = (res.data || []).filter((g) => g && (typeof g.id === "string" || typeof g.id === "number"));
  return (
    <div data-m="M14" data-testid="groups-page">
      <V3Title title="Kreise und Gruppen entdecken" intro="Sieh dir öffentliche Kreisvorschauen an und frage den Beitritt bewusst an." />
      {res.error ? <ConnectionError onRetry={res.reload} /> : !res.data ? <Loading /> : (<>
        <ResultTable testid="member-groups-table" label="Kreise">
          {list.map((g) => <ResultRow key={g.id} initial={initial(g)} title={groupName(g)} context={groupContext(g)} to={groupHref(g)} testid={`member-group-${g.id}`} />)}
          {!list.length && <ResultRow initial="–" title="Noch keine Kreise" context="Sobald es Kreise gibt, findest du sie hier." action="" testid="groups-empty" />}
          <ResultRow initial="I" title="Interne Inhalte" context="Erst nach bestätigter Aufnahme sichtbar" action="" testid="groups-internal-rule" />
        </ResultTable>
        {list[0] && <V3Actions className="mt-[17px]">
          <Link to={groupHref(list[0])} data-testid="groups-open-first" className={V3_PRIMARY}>Kreis ansehen<span className="sr-only">: {groupName(list[0])}</span></Link>
        </V3Actions>}
      </>)}
      <div className="mt-[22px] flex flex-wrap gap-2">
        <Link to="/kreise/vorschlagen" data-testid="groups-propose" className={V3_GHOST}><Plus className="h-4 w-4" aria-hidden="true" />Kreis vorschlagen</Link>
        <Link to="/kreise/einladungen" data-testid="groups-invitations" className={V3_GHOST}><MailOpen className="h-4 w-4" aria-hidden="true" />Einladungen</Link>
        <Link to="/kreise/aufnahmeanfragen" data-testid="groups-requests" className={V3_GHOST}><Inbox className="h-4 w-4" aria-hidden="true" />Aufnahmeanfragen verwalten</Link>
      </div>
    </div>
  );
}
